import { useLayoutEffect } from "react";
import { purgeExpiredToken } from "../authStorage";

/** Clears expired JWT from localStorage on any admin route visit. */
export default function AdminSessionCleanup() {
  useLayoutEffect(() => {
    purgeExpiredToken();
  }, []);

  return null;
}
